import React from "react"
import { explanationWrapper, explanationTitle, explanationParagraph } from "./explanation.module.css"
import RichTextContent from "../rich-text-content"

const ExplanationEmbed = ({ data }) => {

    return (
        <aside className={explanationWrapper}>

            <p className={explanationTitle}>{data.title}</p>

            <RichTextContent content={data.body} />

        </aside>
    )
}

export default ExplanationEmbed
